export const SUCCESS = 0
export const MSGFAIL = 10001

